<!-- <app-nav class="w-100"></app-nav> -->
<!-- <section class="banner">
  <div #air id="air" class='air kenburns-top'></div>
  <app-all-data-view-header [breadcrumbs]="breadcrumbs" [heading]="page_heading" [sub_heading]="page_subheading"
    [datatype]="currentTypeFilter"></app-all-data-view-header>
</section> -->
<app-admin-header
  [header]="page_heading"
></app-admin-header>

<div class="container-fluid">
  <div class="row">

    <div class="col-12 text-center my-3">
      <h2 class="fw-bold section-title-above">{{ "مثال حي للحالات المختلفة" | translator }}</h2>
    </div>

    <div class="col-12 d-flex justify-content-start align-items-center wrapp">

      <div class="custom-cat-search-btn">
        <span class="p-input-icon-right w-100">
          <i class="pi pi-search"></i>
          <input pInputText [(ngModel)]="filterText" placeholder="{{ 'Search...' | translator }}"
            class="custom-cat-search-input" />
        </span>
      </div>

      <ng-container *ngIf="datatypes && datatypes.length > 0">
        <div class="custom-cat-btn" style="cursor: pointer;" *ngFor="let n of datatypes"
          (click)="applyTypeFilter(n?.name)" [ngClass]="currentTypeFilter == n?.name ? 'active' : ''">
          <span class="custom-cat-btn-num">{{n.count}}</span>
          <span><i class="pi-fw {{n?.icon}} mx-2 icon-1-2rem"></i></span>
          <span>{{n?.arabic}}</span>
        </div>

        <div class="custom-cat-btn" style="cursor: pointer;" routerLink="/services/pdf-builder" [queryParams]="{id: ou, type:currentTypeFilter}">

          <span [hidden]="processing"><i class="pi-fw pi pi-print mx-2 icon-1-2rem"></i></span>
          <span [hidden]="!processing"><i class="pi-fw pi pi-spin pi-spinner mx-2 icon-1-2rem"></i></span>

          <span [hidden]="processing">{{"Create a directory" | translator}} {{currentTypeFilter_arabic}}</span>
          <span [hidden]="!processing">{{ "Generating... Please wait" | translator}}</span>
        </div>
      </ng-container>

      <!-- <div *ngIf="hasPermission('PRINT_SERVICE', 'a') || (!isLoggedIn && hasDefaultPrintPermission())">
        <button *ngIf="(data && data !=null && data.length > 0); else loadingBar;" class="custom-cat-btn active"
          style="cursor: pointer;" [useExistingCss]="true"
          [printStyle]="{'#print-data':{'display':'block'},'*':{'direction': 'rtl'},'html':{'direction': 'rtl'},'body':{'direction': 'rtl'}, 'p img': {'width': 'auto !important'}  }"
          printSectionId="print-data" ngxPrint>

          <i class="pi-fw mx-2 icon-1-2rem pi pi-download"></i>

          <span>{{"download directory" | translator}} {{currentTypeFilter_arabic}}</span>
        </button>
      </div> -->

    </div>

    <div class="col-12" *ngIf="loading || (items && items.length > 0)">
      <app-all-data-view-items [items]="items" [filterItems]="items" [filterText]="filterText" [loading]="loading" [object]="ou_object" [type]="data_type"
        [datatype]="currentTypeFilter" [gotoLink]="gotoLink"></app-all-data-view-items>
    </div>

    <div class="col-12" *ngIf="!loading && dataitems && dataitems.length > 0">
      <app-all-data-view-items [items]="dataitems" [filterItems]="dataitems" [filterText]="filterText" [loading]="loading" [object]="ou_object"
        [type]="currentTypeFilter_arabic" [datatype]="currentTypeFilter" [gotoLink]="'data'"></app-all-data-view-items>
    </div>

  </div>
</div>

<!-- Printing Service Use Only For bulk data -->
<div *ngIf="data && data.length > 0" style="display:none; width: 100%;">

  <style type="text/css">
    p,
    td,
    .datacontent {
      color: black
    }
  </style>

  <div class="front-page" style="width: 100%; height: 100%; display: grid; 
  background-size: cover; background-position: center bottom; background-repeat: no-repeat;"
    [style.background-image]="'url(../../../assets/printback-'+ random(0,6).toString() +'.jpg)'">

    <div style="margin-top: 20px;place-self: flex-start;padding: 20px;">
      <img src="../../../assets/sbc_logo.svg" style="height: 50px" class="img-fluid">
    </div>

    <div *ngIf="tableofItems[0].heading != page_heading && page_heading != 'دليل الخدمات الحكومية'"
      style="text-align: center; display: flex; flex-direction: row; justify-content: center; align-items: center;">

      <img src="{{GlobalConstants.staticFilesURL + tableofItems[0].heading_icon}}"
        style="height: 50px; width: auto; margin:20px" class="img-fluid">
      <h2 style="font-weight: bold;line-height: 2; text-wrap: nowrap; color: #2B2A66;">{{ tableofItems[0].heading }}
      </h2>
    </div>

    <div style="display: flex; align-items:center; flex-direction: column; text-align: center; padding:30px"
      *ngIf="tableofItems[0].heading != page_heading">
      <h1 style="font-size:45px; color: #2B2A66; font-weight: 800 ; text-wrap: nowrap;">{{currentTypeFilter+" for print"
        | translator}}</h1>

      <h1 style="font-size:45px; color: #2B2A66; font-weight: 800 ; text-wrap: nowrap;">{{page_heading}}</h1>
      <hr *ngIf="tableofItems[0].heading != page_subheading" class="hr" style="margin:10px">
      <h3 *ngIf="tableofItems[0].heading != page_subheading"
        style="font-size:25px; color: #2B2A66; font-weight: bold; text-wrap: nowrap;">{{page_subheading}}</h3>
    </div>

    <div style="display: flex; align-items:center; flex-direction: column;"
      *ngIf="tableofItems[0].heading == page_heading">

      <h1 style="font-size:45px; color: #2B2A66; font-weight: 800 ; text-wrap: nowrap;">{{currentTypeFilter+" for print"
        | translator}}</h1>

      <div
        style="text-align: center; display: flex; flex-direction: row; justify-content: center; align-items: center;">
        <img src="{{GlobalConstants.staticFilesURL + tableofItems[0].heading_icon}}"
          style="height: 70px; width: auto; margin:20px" class="img-fluid">
        <h1 style="font-size:45px; color: #2B2A66; font-weight: 800 ; text-wrap: nowrap;">{{ tableofItems[0].heading }}
        </h1>
      </div>

      <hr class="hr" style="margin:10px">

      <h3 style="font-size:25px; color: #2B2A66; text-wrap: nowrap;"
        *ngIf="page_subheading != 'المعرفة | التدريب | التطوير' && page_subheading != tableofItems[0].heading ">
        {{page_subheading}}</h3>


    </div>

    <!-- <div>
      <img src="../../../assets/printback.jpg" style="width: 100vw;
      margin-bottom: -25vh;" class="img-fluid">
    </div> -->


    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px" y="0px" viewBox="0 0 595.24 230.9"
      style="enable-background:new 0 0 595.24 230.9; place-self: end; width: 100vw" xml:space="preserve">
      <style type="text/css">
        .st0 {
          fill: #2B2A66;
        }

        .st1 {
          fill: #792C82;
        }

        .st2 {
          fill: #FFFFFF;
        }

        .st3 {
          font-weight: 800;
        }

        .st4 {
          font-size: 33.5162px;
        }

        .st5 {
          font-weight: 800;
        }

        .st6 {
          font-size: 15.962px;
        }

        .st7 {
          fill: none;
          stroke: #C391C1;
          stroke-width: 6;
          stroke-linecap: round;
          stroke-miterlimit: 10;
          stroke-dasharray: 11.6048, 13.539;
        }
      </style>
      <rect x="95.04" y="119.99" class="st0" width="500.21" height="110.91" />
      <path class="st1" d="M0,77.71l94.94-65.86c10.99-7.05,23.64-11.09,36.68-11.68c35.37-1.59,99.95,6.38,98.09,86.17
	c-0.52,22.48-8.39,44.18-21.96,62.11l-95.55,82.32L0.21,230.9L0,77.71z" />

      <!-- Rectangle as the bounding box -->
      <rect #boundingBox x="86.15" y="75.96" width="100" height="56" fill="none" stroke="none" />

      <ellipse transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.7337 128.4215)" cx="130.15" cy="75.96" rx="56" ry="56"
        class="st7"></ellipse>
      <text transform="matrix(1 0 0 1 162.5192 68.1995)" class="st2 st3 st6">
        {{"Print Items" | translator}}
      </text>
      <!-- <text transform="matrix(1 0 0 1 169.437 111.5614)" class="st2 st5 st6" clip-path="url(#textClip)">{{currentTypeFilter_arabic}}</text> -->

      <!-- Text element with clip-path to ensure it stays within the rectangle -->
      <text #dynamicText transform="matrix(1 0 0 1 162.437 111.5614)" class="st2 st5 st4" clip-path="url(#textClip)">
        <!-- {{currentTypeFilter_arabic}} -->
        {{data.length}}
      </text>

    </svg>

  </div>

  <div *ngIf="tableofItems" style="padding: 20px;" style="page-break-before: always; margin: 50px">

    <h1 style="text-align: center; width: 100%;">{{"Table of contents" | translator}}</h1>

    <table style="width: 100%; margin: 10px 0px;">
      <tr>

        <td style="width:10%; margin-left: 5px; color: #27306F;">{{"aljaha" | translator}}</td>
        <td style="width:20%; color: #27306F;">{{"almastue alraise" | translator}}</td>
        <td style="width:40%; ">{{"alkhidmat" | translator}}</td>

        <td style="width:30%">{{"almastuie alfaraie" | translator}}</td>

      </tr>
    </table>

    <div *ngFor="let heading of tableofItems; let headingIndex = index" style="margin-bottom: 10px;">

      <div style="display: flex; align-items: center;">
        <span style="margin-right: 10px;">
          <span>{{headingIndex+1}}. </span>
          <img src="{{GlobalConstants.staticFilesURL + heading?.heading_icon}}"
            *ngIf="checkisImg(heading?.heading_icon); else elseBlock"
            style="width: 20px; height: auto; margin-left:10px;" class="img-fluid" alt="">
          <ng-template #elseBlock>
            <i class="pi pi-{{heading.heading_icon}} img-fluid"></i>
          </ng-template>
        </span>
        <p style="font-weight: bold;line-height: 2; color: #27306F;" [innerHTML]="heading.heading | safeHTML"></p>
      </div>

      <div *ngFor="let subheading of heading.subheadings; let subheadingIndex = index"
        style="margin-left: 20px; margin-bottom: 5px;">

        <div style="display: flex; align-items: center;">
          <span style="margin-right: 30px;">
            <span>{{headingIndex+1}}.{{subheadingIndex+1}} </span>
            <img src="{{GlobalConstants.staticFilesURL + subheading?.subheading_icon}}"
              *ngIf="checkisImg(subheading?.subheading_icon); else elseBlock"
              style="width: 20px; height: auto;  margin-left:10px;" class="img-fluid" alt="">
            <ng-template #elseBlock>
              <i class="pi pi-{{subheading.subheading_icon}} img-fluid"></i>
            </ng-template>
          </span>
          <p style="font-weight: bold;line-height: 2; color: #27306F;" [innerHTML]="subheading.subheading | safeHTML">
          </p>
        </div>

        <table style="width: calc(100% - 60px); margin-right: 60px;">
          <tr *ngFor="let item of subheading.items; let itemIndex = index">

            <td style="width:10%; margin-left: 5px;">{{headingIndex+1}}.{{subheadingIndex+1}}.{{itemIndex+1}}</td>
            <td style="width:60%">{{ item.title }}</td>

            <td style="width:30%">

              <table>

                <tr>

                  <td style="width: 10%; padding-left: 5px;">
                    <img src="{{GlobalConstants.staticFilesURL + item?.subsubheading_icon}}"
                      *ngIf="checkisImg(item?.subsubheading_icon); else elseBlock"
                      style="width: 15px; height: auto;  margin-left:10px;" class="img-fluid" alt="">
                    <ng-template #elseBlock>
                      <i class="pi pi-{{item.subsubheading_icon}} img-fluid" style="font-size: smaller;"></i>
                    </ng-template>
                  </td>

                  <td style="width: 90%; font-size: small;" [innerHTML]="item.subsubheading | safeHTML">{{
                    item.subsubheading }}</td>
                </tr>

              </table>





            </td>

          </tr>
        </table>
      </div>
    </div>
  </div>

  <ng-container *ngFor="let heading of tableofItems; let headingIndex = index">


    <ng-container *ngFor="let subheading of heading.subheadings; ;  let subheadingIndex = index">

      <ng-container *ngFor="let item of subheading.items; let itemIndex = index">

        <ng-container *ngIf="data[item.item_num] as currentItem">


          <div style="page-break-before: always;">
            <!-- Printing Service Use Only -->
            <div *ngIf="currentItem && currentItem?.fields.length > 0">
              <h3 style="margin:10px">{{headingIndex+1}}.{{subheadingIndex+1}}.{{itemIndex+1}}</h3>
              <h2 class="card-title" style="font-weight: 600; color: #27306F;;margin-bottom: 2rem;">
                {{currentItem.name}}</h2>

              <div class="d-flex flex-row w-100 left-0 pb-2 wrapp">
                <ng-container *ngIf="currentItem && currentItem.breadcrumbs && currentItem.breadcrumbs.length > 0">
                  <span class="d-flex flex-row align-items-center"
                    *ngFor="let parent of sortByDepth(currentItem?.breadcrumbs)">
                    <span class="btn-flex custom-bredcrum-btn ou-item  align-items-center">
                      <span class="btn-css  mx-2 font-0_5rem">{{parent.label}}</span>
                      <span>
                        <img src="{{GlobalConstants.staticFilesURL + parent?.icon}}"
                          *ngIf="checkisImg(parent?.icon); else elseBlock" style="width:20px; height:auto;"
                          class="img-fluid" alt="">
                        <ng-template #elseBlock>
                          <i class="pi pi-{{parent.icon}} img-fluid"></i>
                        </ng-template>
                      </span>
                    </span>
                  </span>
                </ng-container>
              </div>

              <div style="margin:1rem 0;"></div>
              <span class="hr"></span>

              <div *ngFor="let field of currentItem?.fields; let i = index">
                <div class="d-flex align-items-center">
                  <i [ngClass]="field.label?.icon + ' font-1_2rem'" style="color: #27306F;font-weight: 800;"
                    class="m-2"></i>
                  <h3 class="vertical-align-middle font-1_1rem" style="color: #27306F;font-weight: 800;">
                    {{field.label?.name}}</h3>
                </div>

                <div class="row" style="margin: 0.5rem 1rem">
                  <!-- For View -->
                  <div class="col-12">
                    <div [ngSwitch]="getFieldType(field.label?.type)">
                      <!-- For text -->
                      <div *ngSwitchCase="'text'">
                        <div class=" line-space mb-0 datacontent" *ngIf="field.data"
                          [innerHTML]="field.data | safeHTML">
                        </div>
                      </div>
                      <!-- Rich text -->
                      <div *ngSwitchCase="'Rich text'">
                        <div class=" line-space mb-0 datacontent" *ngIf="field.data"
                          [innerHTML]="field.data | safeHTML">
                        </div>
                      </div>
                      <div *ngSwitchCase="'Upload Image'">
                        <img [hidden]="field.data == ''" class="img-fluid upload-img"
                          [src]="GlobalConstants.staticFilesURL+field.data">
                      </div>
                      <div *ngSwitchCase="'Upload Document'">
                        <a class="doc-view" [hidden]="field.data == ''" target="_blank"
                          [href]="GlobalConstants.staticFilesURL+field.data">
                          <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{"Add file" | translator}}
                        </a>

                      </div>
                      <div *ngSwitchCase="'Data Item'" style="padding:20px; margin:20px;">
                        <p class="color-bold" style="color: #27306F;">{{field?.data?.name}}</p>

                        <div class="my-3" *ngFor="let field of sortFiled(field.data.fields); let i = index"
                          iconPos="end">

                          <div class="d-flex align-items-center" style="padding:10px; margin:10px">
                            <i [ngClass]="field.label?.icon + ' font-1_2rem'" style="color: #27306F;font-weight: 800;"
                              class="m-2"></i>
                            <span class="vertical-align-middle font-1_1rem"
                              style="color: #27306F;font-weight: 800;">{{field.label?.name}}</span>
                          </div>


                          <div class="row">
                            <div class="col-10">
                              <div [ngSwitch]="getFieldType(field.label?.type)">
                                <!-- For text -->
                                <div *ngSwitchCase="'text'">
                                  <div class=" line-space mb-0 datacontent flex-column" *ngIf="field.data"
                                    [innerHTML]="field.data | safeHTML">
                                  </div>
                                </div>
                                <!-- Rich text -->
                                <div *ngSwitchCase="'Rich text'">
                                  <div class=" line-space mb-0 datacontent flex-column" *ngIf="field.data"
                                    [innerHTML]="field.data | safeHTML">
                                  </div>
                                </div>
                                <div *ngSwitchCase="'Upload Image'">
                                  <img [hidden]="field.data == ''" class="img-fluid upload-img"
                                    [src]="GlobalConstants.staticFilesURL+field.data">
                                </div>
                                <div *ngSwitchCase="'Upload Document'">
                                  <a class="doc-view" [hidden]="field.data == ''" target="_blank"
                                    [href]="GlobalConstants.staticFilesURL+field.data">
                                    <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{"Add file" |
                                    translator}}
                                  </a>

                                </div>
                                <div *ngSwitchCase="'Data Item'">
                                </div>
                                <div *ngSwitchDefault>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>

                      </div>
                      <div *ngSwitchDefault></div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </ng-container>


      </ng-container>



    </ng-container>


  </ng-container>

  <div class="print-footer"
    style="page-break-before: always; width: 100%; height: 100%; background-color: #28306F; display: grid; print-color-adjust: exact;">

    <img src="../../../assets/print_footer.png" style="place-self: center; width: 400px;">

  </div>
</div>

<app-footer></app-footer>